import {
    ChangeDetectionStrategy,
    Component, effect,
    inject,
    input,
    ViewEncapsulation
} from '@angular/core';
import { CmsLayoutComponent, IAppLayoutConfig } from '../cms-layout';
import { SeoService } from '@seven1/angular/seo';
import { IPageBlok } from './page.model';
import { CmsComponent } from '@seven1/angular-storyblok-cms';

@Component({
    selector: 'app-page',
    imports: [CmsLayoutComponent, CmsComponent],
    templateUrl: './page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class PageComponent {
    private _seo = inject(SeoService);

    block = input.required<IPageBlok>();
    layout = input.required<IAppLayoutConfig>();

    constructor() {
        effect(() => {
            const blok = this.block();
            this._seo.addPageMeta(blok);
        });
    }
}
